<template>
    <div>
        <card-header title="Content Providers" icon="fa-person-chalkboard" />

        <card-toolbar v-if="currentUser.isAdmin || currentUser.isSuper">
            <button @click="$openCard('new-content-provider', {}, card)"><i class="far fa-plus"></i>New Provider</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <subheader-list-item icon="fa-person-chalkboard" title="Content Providers" />

                <content-provider-tile
                    v-for="p in providers"
                    :provider="p"
                >
                </content-provider-tile>
            </card-list>
        </card-body>

    </div>
</template>

<script>
    import CardHeader from "@/components/common/CardHeader";
    import CardBody from "@/components/common/CardBody";
    import {client as http} from '@/http_client';
    import CardFooter from "@/components/common/CardFooter";
    import {mapGetters} from "vuex";
    import CardList from "../../TIER/components/CardList.vue";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem.vue";
    import ContainerListItem from "../../TIER/components/ContainerListItem.vue";
    import CardToolbar from "../../TIER/components/CardToolbar.vue";
    import ContentProviderTile from "../../components/tiles/ContentProviderTile.vue";

    export default {
        components: {ContentProviderTile, CardToolbar, ContainerListItem, SubheaderListItem, CardList, CardFooter, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                providers: []
            }
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            load: function () {
                this.$emit('loading', true);
                http.get('content-providers', {force: true}).then(response => {
                    this.providers = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            reload: function () {
                this.load();
            }
        },
        mounted: function () {
            this.load();
        }
    }
</script>
